import * as React from "react";
const SvgEmpty = (props) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 14, viewBox: "0 0 13 14", fill: "#000000", xmlns: "http://www.w3.org/2000/svg", ...props });
export default SvgEmpty;
